import { spacing as spacingOptions } from 'shared/theme';
import styled from 'styled-components';

export interface BaseProps {
  spacing?: keyof typeof spacingOptions | null;
  pointer?: boolean;
  marginRight?: string;
  padding?: string;
}

export const Base = styled.div<BaseProps>`
  margin-bottom: ${({ spacing }) =>
    spacing === undefined || spacing === null ? 0 : spacingOptions[spacing]};
  cursor: ${({ pointer }) => (pointer ? 'pointer' : 'unset')};
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : 'unset')};
  padding: ${({ padding }) => (padding ? padding : 'unset')};
`;
